import { marketingPreferencesService } from '@afterpaytouch/portal-api/consumer/subscriptions/marketing'

export const {
  useGetMarketingPreferencesQuery,
  useSubscribeToMarketingEmailsMutation,
  endpoints: { getMarketingPreferences },
} = marketingPreferencesService
